var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNasa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_382",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29031",
    "data-name": "Group 29031",
    transform: "translate(-3894 4899)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3894, -4899)",
    filter: "url(#Ellipse_382)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_382-2",
    "data-name": "Ellipse 382",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-nasa",
    transform: "translate(3908.132 -4888.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50710",
    "data-name": "Path 50710",
    d: "M23,5A18,18,0,1,0,41,23,18,18,0,0,0,23,5Z",
    transform: "translate(-0.105)",
    fill: "#2a2f96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50711",
    "data-name": "Path 50711",
    d: "M4.513,28.789H3s3.862-2.922,12.248-5.244c0,0,13.455-4.086,22.195-10.026,3.04-2.563,5.414-4.849,6.294-6.52,0,0-1.13,4.476-6.372,9.806-1.026.526-1.427,1.221-2.154,1.562.119-.135-.091-.825,0-.947,0,0-6.816,3.178-20.861,7.361A40.125,40.125,0,0,0,4.513,28.789Z",
    transform: "translate(0 -0.105)",
    fill: "#e53935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50712",
    "data-name": "Path 50712",
    d: "M19.153,25l1.424.024-.73-1.738Zm-.3,1.085-.26.909.76.418-2.521,0,.783-.439,1.624-5.307-.886-.442h3l2.5,5.749.5.442h-3.5l.5-.442-.5-.885h-2Zm9.617-2.835c.546.128,2.393,1.083,1.751,2.964,0,0-.8,2.346-5.149.945l-.485.473v-1.89l.485.473s3.308,1.251,3.291-.3c0-.3-.571-.8-2.089-.993a1.8,1.8,0,0,1-1.687-2.016c.008-.8.593-2.808,4.851-1.418l.44-.491-.01,1.86-.429-.424s-2.521-.79-2.772-.008C26.4,23.256,27.712,23.07,28.473,23.249Z",
    transform: "translate(-0.728 -0.842)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50713",
    "data-name": "Path 50713",
    d: "M37.858,17.149a34.027,34.027,0,0,1-4.641,3.894s-12.909,8.342-18.031,12.1A21.3,21.3,0,0,0,9,39.745V38.212a32.122,32.122,0,0,1,7.186-6.572C20.627,28.495,33.9,20.555,35.526,17.955Z",
    transform: "translate(-0.316 -0.639)",
    fill: "#e53935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50714",
    "data-name": "Path 50714",
    d: "M8.667,21.256h3l2.5,3.981V21.7l-.5-.442h2l-.5.442v5.307l.5.442h-3l-2.5-3.98v3.537l.5.442h-2l.5-.442V21.7Zm24.417,3.807,1.535-.007-.824-1.818ZM32.927,26.1l-.313.885.813.442-2.521,0,.783-.439,1.624-5.307-.886-.442h3l2.5,5.749.5.442h-3.5l.5-.442-.5-.885h-2Z",
    transform: "translate(-0.298 -0.854)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50715",
    "data-name": "Path 50715",
    d: "M32.565,29.3a27.336,27.336,0,0,0-4.492-8.964c-4.557-6.236-10.327-9.733-12.863-7.8-1.247.953-1.541,3.032-.825,5.856a27.336,27.336,0,0,0,4.492,8.964,24.285,24.285,0,0,0,2.553,3.072l.644.242a32.252,32.252,0,0,1-2.955-3.5,26.992,26.992,0,0,1-4.442-8.856c-.682-2.694-.429-4.659.713-5.532a2.558,2.558,0,0,1,1.593-.491c2.795,0,7.2,3.232,10.848,8.227a26.992,26.992,0,0,1,4.442,8.856c.682,2.694.429,4.659-.713,5.532-1.532,1.17-4.363.171-7.37-2.287l-.208.213c2.229,1.815,4.383,2.854,6.029,2.854a2.767,2.767,0,0,0,1.729-.534C32.986,34.2,33.279,32.119,32.565,29.3Z",
    transform: "translate(-0.579 -0.368)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50716",
    "data-name": "Path 50716",
    d: "M.412,0C.185,0,0,.449,0,1S.185,2,.412,2s.412-.449.412-1S.64,0,.412,0Z",
    transform: "translate(20.161 29.326) rotate(-43.348)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50717",
    "data-name": "Path 50717",
    d: "M26.526,7.389,26.745,8.9a.326.326,0,0,0,.275.275l1.506.218-1.507.219a.326.326,0,0,0-.275.275l-.218,1.506-.219-1.507a.326.326,0,0,0-.275-.275l-1.506-.218,1.507-.219a.326.326,0,0,0,.275-.275ZM18,14.021l.219,1.507a.326.326,0,0,0,.275.275L20,16.02l-1.507.219a.326.326,0,0,0-.275.275L18,18.02l-.219-1.507a.326.326,0,0,0-.275-.275L16,16.02l1.507-.219a.326.326,0,0,0,.275-.275Zm.947,19.895.219,1.507a.326.326,0,0,0,.275.275l1.506.218-1.507.219a.326.326,0,0,0-.275.275l-.218,1.506-.219-1.507a.326.326,0,0,0-.275-.275l-1.506-.218,1.507-.219a.326.326,0,0,0,.275-.275Zm18-6.632.219,1.507a.326.326,0,0,0,.275.275l1.506.218L37.44,29.5a.326.326,0,0,0-.275.275l-.218,1.506-.219-1.507a.326.326,0,0,0-.275-.275l-1.506-.218,1.507-.219a.326.326,0,0,0,.275-.275Zm-1.895,4.368a.474.474,0,1,0,.474.474A.474.474,0,0,0,35.053,31.652ZM12.316,30.7a.474.474,0,1,0,.474.474A.474.474,0,0,0,12.316,30.7ZM9.474,28.81a.474.474,0,1,0,.474.474A.474.474,0,0,0,9.474,28.81Zm14.211-18a.474.474,0,1,0,.474.474A.474.474,0,0,0,23.684,10.81Zm-3.789,6.632a.474.474,0,1,0,.474.474A.474.474,0,0,0,19.895,17.442Z",
    transform: "translate(-0.316 -0.126)",
    fill: "#fafafa"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNasa);
export default __webpack_public_path__ + "static/media/nasa.b7d6e4b7ba20a902f440cc2e1fee3f20.svg";
export { ForwardRef as ReactComponent };